import { render, staticRenderFns } from "./AdsAndOffers.vue?vue&type=template&id=3f2e1a5a&scoped=true&"
import script from "./AdsAndOffers.vue?vue&type=script&lang=js&"
export * from "./AdsAndOffers.vue?vue&type=script&lang=js&"
import style0 from "./AdsAndOffers.vue?vue&type=style&index=0&id=3f2e1a5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e1a5a",
  null
  
)

export default component.exports